module.exports = __webpack_public_path__ + "static/img/48-3.94a8874.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/48-3.jpg
// module id = LGnH
// module chunks = 0